import { Notification } from '../../models/users/notification';

export interface UserState {
  value?: any;
  notifications: {
    eventNotifications: { date: string; events: Notification[] }[];
    messageNotifications: { date: string; messages: Notification[] }[];
    notificationAmount: number;
    newEvents: number[];
    newMessages: number[];
    loading: boolean;
    eventsNext: any;
    messagesNext: any;
  };
  locations: any[];
  error: any;
}

export const initialUserState: UserState = {
  value: null,
  notifications: {
    eventNotifications: [],
    messageNotifications: [],
    notificationAmount: 0,
    newEvents: [],
    newMessages: [],
    loading: false,
    eventsNext: null,
    messagesNext: null,
  },
  locations: [],
  error: null,
};
